export default "__VITE_PUBLIC_ASSET__bc242cd7__"